import { LoggerFactory } from '@elderbyte/ts-logger'
import { PackageGroupRow } from './package-group-row'
import { PackageNodeGroup } from './storage-manager-packages.component'
import { Sort, SortUtil } from '@elderbyte/ngx-starter'

export class PackageGroupRowBuilder {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private static readonly log = LoggerFactory.getLogger('PackageGroupRowBuilder')

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public static buildRows(packageNodeGroups: PackageNodeGroup[]): PackageGroupRow[] {
    let rows: PackageGroupRow[] = []

    // Ensure PackageGroup order.
    packageNodeGroups = SortUtil.sortData(packageNodeGroups, [
      new Sort('storagePath.elements', 'asc'),
    ])

    packageNodeGroups.forEach((group) => {
      // Ensure Package order in PackageGroup.
      const newRows = SortUtil.sortData(this.buildGroupRows(group), [
        new Sort('item.number', 'asc'),
      ])
      rows = rows.concat(newRows)
    })

    return rows
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private static buildGroupRows(packageNodeGroup: PackageNodeGroup): PackageGroupRow[] {
    const rows: PackageGroupRow[] = []
    const packages = packageNodeGroup.packages

    if (packages?.length > 0) {
      const childRows = packages.map((p) => new PackageGroupRow(packageNodeGroup, p, null, true))
      const summaryRow = new PackageGroupRow(packageNodeGroup, null, childRows)
      rows.push(summaryRow)
      rows.push(...childRows)
    } else {
      const summaryRow = new PackageGroupRow(packageNodeGroup, null)
      rows.push(summaryRow)
    }

    return rows
  }
}
